import { gql } from "@apollo/client";

export const newcustomerCategoryOption = [
  "BAKE",
  "CAF",
  "CS",
  "CSH",
  "OTH",
  "REST",
  "SMT",
  "TRD",
  "WHS",
];

export const newcustomerStatusOption = ["Yet to Visit", "Completed"];
//  GET query
export const listAllCustomers = gql`
  query {
    allCustomerDetails {
      data {
        id
        createdAt
        customerCategory

        customerCode

        customerName

        phoneNo

        email

        address

        startDate

        customerProfile

        priceCode

        locationLat
        user {
          employeeName
        }
        locationLng
      }

      success

      message

      error
    }
  }
`;

export const getNewCustomerById = gql`
  query getcustomerdetails($id: ID!) {
    customerDetails(id: $id) {
      data {
        customerCategory

        customerCode

        customerName

        phoneNo

        email

        address

        startDate

        customerProfile
        customerPlace

        priceCode

        locationLat

        locationLng
      }

      success

      message

      error
    }
  }
`;
// Api for create new customer
export const newcreateCustomer = gql`
  mutation createcustomerdetails($input: CreateCustomerDetailsInput!) {
    createCustomerDetails(input: $input) {
      success

      message

      error
    }
  }
`;

export const uploadNewCustomerList = gql`
  mutation updatecustomerdetails($input: UpdateCustomerDetailsInput!) {
    updateCustomerDetails(input: $input) {
      success

      message

      error
    }
  }
`;
// Api fot Export
export const exportNewCustomer = gql`
  mutation exportCustomers($fromDate: Date!, $toDate: Date!) {
    exportCustomers(fromDate: $fromDate, toDate: $toDate) {
      success
      error
      message
      fileUrl
    }
  }
`;
//   api for filter
export const filterNewCustomer = gql`
  query filterCustomerDateRange($fromdate: Date!, $todate: Date!) {
    filterCustomerDateRange(fromDate: $fromdate, toDate: $todate) {
      success
      message
      error
      data {
        id
        customerCategory
        customerCode
        customerName
        phoneNo
        email
        address
        startDate
        customerProfile
        priceCode
        locationLat
        locationLng
      }
    }
  }
`;
